import { render } from "./SubmenuSupport.vue?vue&type=template&id=7b8836a3"
import script from "./SubmenuSupport.vue?vue&type=script&lang=js"
export * from "./SubmenuSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__